export default "__VITE_ASSET__Dr11OF6s__"